import { api } from 'common';

import { flowBuilderDemoRoutes } from './Routes/demoRoutes';
import { getRoutes } from './Routes/standardRoutes';
import { type Route } from './common';
import { type LaunchDarklyFlags } from '../../utils/flags';

export interface GetFlowStudioRoutesParams {
  featureFlags: api.FeatureFlag.Setting[];
  user: api.User.UserWithOrganizations;
  permissions: api.Group.Permission[];
  launchDarklyFlags: LaunchDarklyFlags;
  hasAnyAgentAccess: boolean;
  hasAnyAgentGrantPermission: boolean;
}

export const getFlowStudioRoutes = (props: GetFlowStudioRoutesParams): Route[] => {
  const {
    featureFlags,
    user,
    permissions,
    launchDarklyFlags,
    hasAnyAgentAccess,
    hasAnyAgentGrantPermission,
  } = props;
  const flowBuilderDemoRoutesFeatureFlag = featureFlags.find(
    (flag) => flag.name === 'enableFlowBuilderDemoRoutes'
  );

  if (flowBuilderDemoRoutesFeatureFlag?.option === api.FeatureFlag.ON) {
    return flowBuilderDemoRoutes;
  }

  return getRoutes({
    user,
    permissions,
    launchDarklyFlags,
    hasAnyAgentAccess,
    hasAnyAgentGrantPermission,
  });
};
